define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/HelpScoutConversationModel", "../../models/HelpScoutThreadModel"], function (require, exports, $, ko, log, tools, HelpScoutConversationModel, HelpScoutThreadModel) {
    "use strict";
    var HelpScoutActions = /** @class */ (function () {
        function HelpScoutActions() {
            this.editConversationModel = ko.observable(new HelpScoutConversationModel());
            this.editThreadModel = ko.observable(new HelpScoutThreadModel());
            this.filterByHelpScoutStatus = ko.observable('active');
            this.filterByHelpScoutPeriod = ko.observable('');
            this.filterByContactId = ko.observable();
            this.filterByCustomerId = ko.observable();
            this.filterByCreatorId = ko.observable();
            this.filterByOwnerId = ko.observable();
            this.filterByAny = ko.observable();
            this.filterByTag = ko.observable();
            this.filterByAccountNumber = ko.observable();
            this.clearInAction = false;
            this.helpScoutInboxes = ko.observableArray([]);
            this.helpScoutUsers = ko.observableArray([]);
            this.contactsDropDownList = ko.observableArray([]);
            this.currentUserId = 0;
        }
        HelpScoutActions.prototype.initHelpScout = function () {
            var self = this;
        };
        HelpScoutActions.prototype.getHelpScoutInboxes = function () {
            var self = this;
            if (self.helpScoutInboxes().length > 0) {
                return;
            }
            return tools.ajaxGet({
                url: '/Support/GetHelpScoutInboxes',
                success: function (data) {
                    if (data.Success) {
                        self.helpScoutInboxes(data.Data.Data);
                    }
                }
            });
        };
        HelpScoutActions.prototype.getHelpScoutUsersLookup = function (initial) {
            if (initial === void 0) { initial = false; }
            var self = this;
            return tools.ajaxGet({
                url: '/Support/GetHelpScoutUsers',
                success: function (data) {
                    if (data.Success) {
                        self.helpScoutUsers(data.Data.Data);
                        if (initial) {
                            self.currentUserId = data.Data.User;
                            self.filterByOwnerId(self.currentUserId);
                        }
                    }
                }
            });
        };
        HelpScoutActions.prototype.editHelpScoutConversation = function (conversationId, table, customerId) {
            if (customerId === void 0) { customerId = null; }
            var self = this;
            var title = 'Create Conversation';
            if (conversationId > 0) {
                title = 'Edit Conversation';
            }
            tools.editModal({
                title: title,
                buttonTitle: 'Save',
                type: 'info',
                modalOptions: {},
                save: function (event, modal) {
                    //validate form            
                    console.log(self.editConversationModel(), self.editConversationModel().CustomerId(), self.editConversationModel().Subject());
                    if (conversationId == 0) {
                        if (!self.editConversationModel().MailboxId()) {
                            if ($('#MailboxContainer', modal).is(":visible")) {
                                tools.error('Inbox is required!');
                                return;
                            }
                        }
                    }
                    if (!self.editConversationModel().CustomerId()) {
                        if ($('#CustomerContainer', modal).is(":visible")) {
                            tools.error('Customer is required!');
                            return;
                        }
                    }
                    if (!self.editConversationModel().ContactId()) {
                        if ($('#CustomerContactContainer', modal).is(":visible")) {
                            tools.error('Contact is required!');
                            return;
                        }
                    }
                    if (!self.editConversationModel().Subject()) {
                        tools.error('Subject is required!');
                        return;
                    }
                    if (!self.editConversationModel().Body()) {
                        if ($('#BodyContainer', modal).is(":visible")) {
                            tools.error('Content is required!');
                            return;
                        }
                    }
                    $(event.currentTarget).button('loading');
                    self.saveHelpScoutConversation(event.currentTarget, modal, table);
                },
                opened: function (modal) {
                    var lookupDataCall = self.getHelpScoutUsersLookup();
                    var contactLookUp = self.getCustomerContacts(customerId);
                    var mailboxLookUp = self.getHelpScoutInboxes();
                    var getModelCall = null;
                    if (conversationId > 0) {
                        getModelCall = tools.ajaxGet({
                            url: '/Support/GetHelpScoutConversationById',
                            data: { conversationId: conversationId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editConversationModel(new HelpScoutConversationModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editConversationModel(new HelpScoutConversationModel());
                    }
                    $.when(getModelCall, lookupDataCall, mailboxLookUp, contactLookUp).done(function (data) {
                        $(modal).find('.modal-body').html("<div data-bind=\"template: { name: 'hs-edit-con-template', data: editConversationModel }\"></div>");
                        ko.applyBindings(self, modal);
                        if (customerId > 0) {
                            $(modal).find('#CustomerContainer').hide();
                        }
                        else {
                            self.getCustomers('CustomersEdit');
                        }
                        if (conversationId > 0) {
                            $(modal).find('#BodyContainer').hide();
                            $(modal).find('#CustomerContainer').hide();
                            $(modal).find('#CustomerContactContainer').hide();
                            $(modal).find('#MailboxContainer').hide();
                        }
                        else {
                            $(modal).find('#StatusContainer').hide();
                        }
                        $('#CcBccContainer', modal).hide();
                        if (conversationId > 0) {
                            $('#HelpScoutAccount', modal).addClass('col-md-9');
                            $('#HelpScoutAccount', modal).removeClass('col-md-7');
                            $('#CcBccButton').hide();
                        }
                        else {
                            $(modal).on('click', '.btn-cc-bcc', function (event) {
                                $('#CcBccContainer', modal).show();
                                $('.btn-cc-bcc', modal).attr('disabled', 'disabled');
                                event.preventDefault();
                            });
                        }
                    });
                }
            });
        };
        HelpScoutActions.prototype.saveHelpScoutConversation = function (btn, modal, table) {
            var self = this;
            var obj = ko.mapping.toJS(self.editConversationModel());
            if (!obj.AccountNumber) {
                obj.AccountNumber = self.customerValueTemp;
            }
            obj['__RequestVerificationToken'] = $('#conversationForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: '/Support/SaveHelpScoutConversation',
                data: {
                    param: JSON.stringify({
                        MailboxId: obj.MailboxId,
                        ConversationId: obj.ConversationId,
                        ContactId: obj.ContactId,
                        OwnerId: obj.OwnerId,
                        AccountNumber: obj.AccountNumber,
                        Body: obj.Body,
                        Subject: obj.Subject,
                        Status: obj.Status,
                        Cc: obj.Cc,
                        Bcc: obj.Bcc
                    })
                }
            }).done(function (result) {
                if (result.Success) {
                    if (obj.ConversationId > 0) {
                        tools.success('Conversation changed successfully');
                    }
                    else {
                        tools.success('Conversation started');
                    }
                    table === null || table === void 0 ? void 0 : table.refresh();
                    $(modal).modal('hide');
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button('reset');
            });
        };
        HelpScoutActions.prototype.getCustomers = function (elemId, table) {
            if (table === void 0) { table = null; }
            var self = this;
            self.customersDropDownList = $('#' + elemId).kendoComboBox({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                dataTextField: "Name",
                dataValueField: "Id",
                dataSource: {
                    transport: {
                        read: {
                            url: "/Support/GetCustomers",
                            type: "POST",
                            dataType: "json",
                            data: function () {
                                var data = {
                                    filterText: $('input[name=' + elemId + '_input]').val()
                                };
                                return data;
                            }
                        }
                    },
                    schema: {
                        data: function (response) { return response.Data; },
                        total: "Total"
                    },
                    serverFiltering: true,
                },
                change: function (e) {
                    setTimeout(function () {
                        if (self.filterByAccountNumber() > 0) {
                            $('#' + elemId).closest('div').find('.ContactFilter').show();
                        }
                        else {
                            $('#' + elemId).closest('div').find('.ContactFilter').hide();
                        }
                    });
                    if (table && !self.clearInAction) {
                        table === null || table === void 0 ? void 0 : table.refresh();
                    }
                    self.editConversationModel().CustomerId(this.value());
                    self.filterByAccountNumber(this.value());
                    self.getCustomerContacts(this.value());
                }
            }).data("kendoComboBox");
            self.customersDropDownList.wrapper.width('100%');
        };
        HelpScoutActions.prototype.getCustomerContacts = function (customerId) {
            var self = this;
            return tools.ajaxGet({
                url: '/Support/GetCustomerContacts',
                data: { customerId: customerId },
                success: function (data) {
                    if (data.Success) {
                        self.contactsDropDownList(data.Data);
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        HelpScoutActions.prototype.editHelpScoutThread = function (conversationId, subject, ownerId, table, type) {
            if (type === void 0) { type = 'Reply'; }
            var self = this;
            var title = 'Reply';
            var button = 'Reply';
            if (type == 'Note') {
                title = 'Add Note';
                button = 'Add Note';
            }
            tools.editModal({
                title: title,
                buttonTitle: button,
                type: 'info',
                modalOptions: {},
                save: function (event, modal) {
                    //validate form                          
                    if (!self.editThreadModel().Body()) {
                        tools.error('Content is required!');
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.saveHelpScoutThread(event.currentTarget, modal, table);
                },
                opened: function (modal) {
                    var cc, bcc, lookupCcBcc = null;
                    if (conversationId > 0) {
                        lookupCcBcc = tools.ajaxGet({
                            url: '/Support/GetHelpScoutThreadCcBcc',
                            data: { conversationId: conversationId },
                            success: function (result) {
                                if (result.Success) {
                                    cc = result.Data.Cc;
                                    bcc = result.Data.Bcc;
                                    ownerId = result.Data.OwnerId;
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    var lookupDataCall = self.getHelpScoutUsersLookup();
                    $.when(lookupDataCall, lookupCcBcc).done(function (data) {
                        $(modal).find('.modal-body').html("<div data-bind=\"template: { name: 'hs-edit-th-template', data: editThreadModel }\"></div>");
                        self.editThreadModel(new HelpScoutThreadModel({
                            ConversationId: conversationId,
                            Id: 0,
                            Body: "",
                            Subject: subject,
                            OwnerId: ownerId,
                            Cc: cc,
                            Bcc: bcc,
                            Type: type,
                        }));
                        ko.applyBindings(self, modal);
                        if (cc || bcc) {
                            $('#CcBccContainer', modal).show();
                            $('.btn-cc-bcc', modal).attr('disabled', 'disabled');
                        }
                        else {
                            $('#CcBccContainer', modal).hide();
                        }
                        $(modal).on('click', '.btn-cc-bcc', function (event) {
                            $('#CcBccContainer', modal).show();
                            $('.btn-cc-bcc', modal).attr('disabled', 'disabled');
                            event.preventDefault();
                        });
                    });
                }
            });
        };
        HelpScoutActions.prototype.linkHelpScoutConversation = function (conversationId, customerId, accountNumber, table) {
            var data = {
                conversationId: conversationId,
                accountNumber: accountNumber
            };
            $.ajax({
                url: "/Customers/ToggleLinkConversation",
                type: "POST",
                data: data,
                success: function () {
                    table === null || table === void 0 ? void 0 : table.refresh();
                }
            });
        };
        HelpScoutActions.prototype.saveHelpScoutThread = function (btn, modal, table) {
            var self = this;
            var obj = ko.mapping.toJS(self.editThreadModel());
            obj['__RequestVerificationToken'] = $('#threadForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: '/Support/SaveHelpScoutThread',
                data: {
                    param: JSON.stringify({
                        ConversationId: obj.ConversationId,
                        AssignToId: obj.OwnerId,
                        Body: obj.Body,
                        Cc: obj.Cc,
                        Bcc: obj.Bcc,
                        Type: obj.Type,
                    })
                }
            }).done(function (result) {
                if (result.Success) {
                    tools.success('Reply successful');
                    table === null || table === void 0 ? void 0 : table.refresh();
                    $(modal).modal('hide');
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button('reset');
            });
        };
        HelpScoutActions.prototype.clearFilter = function () {
            var self = this;
            self.clearInAction = true;
            if (self.customersDropDownList) {
                self.customersDropDownList.value(null);
            }
            self.filterByHelpScoutStatus('active');
            self.filterByHelpScoutPeriod('');
            self.filterByContactId(null);
            self.filterByCustomerId(null);
            self.filterByCreatorId(null);
            self.filterByOwnerId(self.currentUserId);
            self.filterByAccountNumber(null);
            self.filterByAny('');
            self.filterByTag('');
            self.clearInAction = false;
        };
        return HelpScoutActions;
    }());
    return HelpScoutActions;
});
//# sourceMappingURL=helpscoutActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/helpscout/helpscoutActions.js
// module id = 84
// module chunks = 2